<template>
  <stormy-dialog
    title="Adressbuch"
    width="lg"
    :show="show"
    @hide="$emit('ab-cancel')"
  >
    <template #content>
      <div class="z-0 flex overflow-hidden flex-1 -ml-3">
        <template v-if="isLoading">
          <stormy-spinner :show="isLoading" />
        </template>
        <template v-else>
          <div class="flex-none overflow-hidden flex">
            <ObuBookingsAddressBookList
              :contacts="contacts"
              @ab-selected="onContactDetails"
            />
          </div>
          <div class="flex-1 flex">
            <ObuBookingsAddressBookListDetails v-if="selectedContact" />
          </div>
        </template>
      </div>
    </template>
    <template #footer>
      <div class="space-x-2">
        <stormy-button
          variant="link"
          @click="$emit('ab-cancel')"
        >
          Abbrechen
        </stormy-button>
        <stormy-button
          varinat="primary"
          @click="onAbSelected"
        >
          Kontakt auswählen
        </stormy-button>
      </div>
    </template>
  </stormy-dialog>
</template>

<script setup>
import { ref, toRefs } from 'vue'
import { storeToRefs } from 'pinia'

import { useContactStore } from '@/pinia/ContactStore.js'
import ObuBookingsAddressBookList from './_components/ObuBookingsAddressBook/ObuBookingsAddressBookList.vue'
import ObuBookingsAddressBookListDetails from './_components/ObuBookingsAddressBook/ObuBookingsAddressBookListDetails.vue'
import { useProp } from '@/composables/useProp.js'

const contactStore = useContactStore()
const { contacts, isLoading } = storeToRefs(contactStore)

const selectedContact = ref(null)
const emit = defineEmits(['ab-cancel', 'ab-selected'])

const props = defineProps({
  show: useProp(Boolean)
})

const { show } = toRefs(props)

const onContactDetails = async (contactId) => {
  await contactStore.find(contactId)
  selectedContact.value = contactId
}

const onAbSelected = () => {
  emit('ab-selected')
}

</script>
